
// document.addEventListener('DOMContentLoaded', () => {
//     const navLogoWpr = document.querySelector('.nav-logo-wpr');
//     const navInner = document.querySelector('.nav-logo-inner'); 

//     window.addEventListener('scroll', () => {
//         if (window.scrollY > 0) {
//             navInner.classList.remove('show-logo-text');
//         }
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//     window.addEventListener('scroll', () => {
//         console.log(window.scrollY)
//         if (window.scrollY > 0) {
//             document.querySelector('.nav-logo-wpr').classList.add('show-logo-icon');
//             document.querySelector('.nav-logo-wpr').classList.remove('loading');
//         }
//     });
// })

const navLogo = document.querySelector('.nav-logo-wpr');
if (sessionStorage.getItem('logoAnimated') === 'true') {
    navLogo.classList.add('show-logo-icon');
    navLogo.classList.remove('loading');
}
window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        navLogo.classList.add('show-logo-icon');
        navLogo.classList.remove('loading');
        sessionStorage.setItem('logoAnimated', 'true');
    }
});
document.addEventListener('DOMContentLoaded', () => {
});